import styled, { css } from "styled-components";

import { truncateText } from "@similarweb/styles";
import { AutocompleteItemWrapper, PopoverContent } from "@similarweb/ui-components";
import { TextField } from "@similarweb/ui-components/forms";

import { ACTIVE_ROW_BACKGROUND } from "app/pages/sales-intelligence/pages/ai-agent/constants";

const ATTENDEES_SEARCH_WIDTH = "320px";

export const StyledAttendeesSearchWrapper = styled.div`
    width: ${ATTENDEES_SEARCH_WIDTH};
    padding: 10px 0;
`;

// TextField sizes itself from a content-box input group with a hardcoded 320px min-width, so it
// has to be pinned to stay aligned with the meeting goal dropdown above it. Same approach as
// StyledRecipientTextField in ../AIAgentEmailToolbar/styles.ts.
export const StyledAttendeesTextField = styled(TextField)`
    && {
        width: ${ATTENDEES_SEARCH_WIDTH};
        box-sizing: border-box;
    }

    & [data-slot="control"] {
        min-width: 0;
        width: 100%;
        box-sizing: border-box;
    }
`;

export const StyledAttendeesPopoverContent = styled(PopoverContent)<{ $width?: number }>`
    max-height: 320px;
    padding: 0;
    overflow-y: auto;
    width: ${({ $width }) => ($width ? `${$width}px` : ATTENDEES_SEARCH_WIDTH)};
    min-width: ${({ $width }) => ($width ? `${$width}px` : ATTENDEES_SEARCH_WIDTH)};
    max-width: ${({ $width }) => ($width ? `${$width}px` : ATTENDEES_SEARCH_WIDTH)};
`;

export const StyledAttendeeOptionContent = styled.div`
    display: flex;
    flex-direction: column;
    flex: 1;
    min-width: 0;

    span {
        display: block;
        max-width: 100%;
        ${truncateText()}
    }
`;

export const StyledAttendeeOption = styled(AutocompleteItemWrapper)<{ isDisabled: boolean; $isActive: boolean }>`
    display: flex;
    align-items: center;
    gap: 8px;
    cursor: ${({ isDisabled }) => (isDisabled ? "not-allowed" : "pointer")};
    opacity: ${({ isDisabled }) => (isDisabled ? 0.5 : 1)};

    ${({ $isActive }) =>
        $isActive &&
        css`
            background-color: ${ACTIVE_ROW_BACKGROUND};
        `};
`;
